const doc = [({"da":({"js":({"forms":({"image_input":({"the_image_was_deleted":"Billedet blev slettet"})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;